export enum ENBConsutantActions {
  OpenChat = 'newbuildingConsultant/openChat',
  ShowMotivationPopup = 'newbuildingConsultant/showMotivationPopup',
  OpenConsultantPopup = 'newbuildingConsultant/openConsultantPopup',
}

export interface IOpenChatAction {
  type: ENBConsutantActions;
  payload: boolean;
}

export function openChat(open: boolean): IOpenChatAction {
  return {
    type: ENBConsutantActions.OpenChat,
    payload: open,
  };
}

export interface IOpenMotivationPopupAction {
  type: ENBConsutantActions;
  payload: boolean;
}

export function openMotivationPopup(showState: boolean): IOpenMotivationPopupAction {
  return {
    type: ENBConsutantActions.ShowMotivationPopup,
    payload: showState,
  };
}

export interface IOpenConsultantPopupAction {
  type: ENBConsutantActions;
  payload: boolean;
}

export function openConsultantPopup(open: boolean) {
  return {
    type: ENBConsutantActions.OpenConsultantPopup,
    payload: open,
  };
}

export type TNewbuildingConsultantActions = IOpenMotivationPopupAction | IOpenChatAction | IOpenConsultantPopupAction;
